import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchCodeSectionsQueryVariables = Types.Exact<{
  codeBookId: Types.Scalars['uuid']['input'];
  search: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SearchCodeSectionsQuery = { __typename?: 'query_root', code_sections: Array<{ __typename?: 'code_sections', id: any, section_number: string, title?: string | null, body: string, page_number?: number | null, depth: number }> };


export const SearchCodeSectionsDocument = gql`
    query searchCodeSections($codeBookId: uuid!, $search: String!, $limit: Int = 25) {
  code_sections(
    where: {code_book_id: {_eq: $codeBookId}, section_number: {_ilike: $search}}
    order_by: {sort_key: asc}
    limit: $limit
  ) {
    id
    section_number
    title
    body
    page_number
    depth
  }
}
    `;

/**
 * __useSearchCodeSectionsQuery__
 *
 * To run a query within a React component, call `useSearchCodeSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCodeSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCodeSectionsQuery({
 *   variables: {
 *      codeBookId: // value for 'codeBookId'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCodeSectionsQuery(baseOptions: Apollo.QueryHookOptions<SearchCodeSectionsQuery, SearchCodeSectionsQueryVariables> & ({ variables: SearchCodeSectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCodeSectionsQuery, SearchCodeSectionsQueryVariables>(SearchCodeSectionsDocument, options);
      }
export function useSearchCodeSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCodeSectionsQuery, SearchCodeSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCodeSectionsQuery, SearchCodeSectionsQueryVariables>(SearchCodeSectionsDocument, options);
        }
export function useSearchCodeSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCodeSectionsQuery, SearchCodeSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCodeSectionsQuery, SearchCodeSectionsQueryVariables>(SearchCodeSectionsDocument, options);
        }
export type SearchCodeSectionsQueryHookResult = ReturnType<typeof useSearchCodeSectionsQuery>;
export type SearchCodeSectionsLazyQueryHookResult = ReturnType<typeof useSearchCodeSectionsLazyQuery>;
export type SearchCodeSectionsSuspenseQueryHookResult = ReturnType<typeof useSearchCodeSectionsSuspenseQuery>;
export type SearchCodeSectionsQueryResult = Apollo.QueryResult<SearchCodeSectionsQuery, SearchCodeSectionsQueryVariables>;